/**
 * @desc 作废
 */
const URL = "/rantion-business";
import http, { updateResponse } from "@/http";
export function request(body: defs.business.CustomerOrderCancelRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/customerOrder/cancel`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
